import BaseApiService from './BaseApiService'

export interface AccessReviewUser {
  userId: string
  emailAddress: string
  role: number
  status: number
  signInCount: number
  lastSignInAt: string | null
  mfaEnabled: boolean
  staleSignIn: boolean
}

export interface AccessReviewApiKey {
  apiKeyId: string
  name: string
  capabilities: string | null
  workspaceId: string | null
  folderId: string | null
  isActive: boolean
  lastUsedAt: string | null
  createdAt: string
  staleUnused: boolean
}

export interface AccessReviewReport {
  generatedAt: string
  staleThresholdDays: number
  users: AccessReviewUser[]
  apiKeys: AccessReviewApiKey[]
  capabilityGrants: { roleId: string; capability: string }[]
  summary: {
    userCount: number
    activeUsers: number
    admins: number
    adminsWithoutMfa: number
    staleUsers: number
    apiKeyCount: number
    staleApiKeys: number
  }
}

class AccessReviewApiService extends BaseApiService {
  report(): Promise<AccessReviewReport> {
    return this.get<AccessReviewReport>('/v1/access-review/report')
  }

  record(notes: string | null): Promise<{ recorded: boolean }> {
    return this.post<{ recorded: boolean }>('/v1/access-review/record', { notes })
  }
}

export const accessReviewApiService = new AccessReviewApiService()
